import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { CreateAccountFormContentPreTest } from "./CreateAccountFormContentPreTest";
import { ValidatePreTestSignupLinkRequest } from "./Services/CreateAccountService";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";

import { TestTube } from "../../assets/iconComponents/TestTube";
import { MaleFemale } from "../../assets/iconComponents/MaleFemale";
import { PregnantWoman } from "../../assets/iconComponents/PregnantWoman";
import { BlankHeader } from "../Header/BlankHeader";
import { ErrorPopup } from "../shared/ErrorPopup/ErrorPopup";
import { Spinner } from "./CreateAccountForm.styles";
import loading from "../../assets/icons/loading.svg";
import {
  CreateAccountCenterFormPreTestInfoGrid,
  CreateAccountCenterFormPreTestInfoTitle,
  CreateAccountCenterFormPreTestInfoRow,
  CreateAccountPretestDesktopContainer,
  CreateAccountPretestMobileContainer,
  CreateAccountCenterPreTestContainer,
  CreateAccountCenterFormPreTestInfoRowContent,
} from "./CreateAccountPreTestForm.styles";

export const CreateAccountFormPreTest: React.FC<{
  setPathname: () => void;
}> = ({ setPathname }) => {
  const { t } = useTranslation();
  const { isDesktop, deviceType } = useDeviceHook();
  const { portalAccountPublicId } = useParams<{
    portalAccountPublicId: string | undefined;
  }>();
  const [validatedPublicId, setValidatedPublicId] = useState<
    string | undefined
  >();
  const [linkStatus, setLinkStatus] = useState<
    "loading" | "valid" | "invalid" | "network-error"
  >(portalAccountPublicId ? "loading" : "valid");

  useEffect(() => {
    let isCurrent = true;

    if (!portalAccountPublicId) {
      setValidatedPublicId(undefined);
      setLinkStatus("valid");
      return () => {
        isCurrent = false;
      };
    }

    setLinkStatus("loading");
    ValidatePreTestSignupLinkRequest(portalAccountPublicId).then((status) => {
      if (!isCurrent) return;

      setValidatedPublicId(portalAccountPublicId);
      if (status === 204) {
        setLinkStatus("valid");
      } else if (status === 404) {
        setLinkStatus("invalid");
      } else {
        setLinkStatus("network-error");
      }
    });

    return () => {
      isCurrent = false;
    };
  }, [portalAccountPublicId]);

  const isValidatedRoute = validatedPublicId === portalAccountPublicId;
  let SignupContent = (
    <CreateAccountCenterPreTestContainer deviceType={deviceType}>
      <Spinner>
        <img src={loading} alt={t("createAccount.preTest.loading")} />
      </Spinner>
    </CreateAccountCenterPreTestContainer>
  );

  if (linkStatus === "valid" && isValidatedRoute) {
    SignupContent = (
      <CreateAccountFormContentPreTest setPathname={setPathname} />
    );
  } else if (linkStatus === "invalid" && isValidatedRoute) {
    SignupContent = (
      <CreateAccountCenterPreTestContainer deviceType={deviceType}>
        <ErrorPopup
          message={t("createAccount.errors.unknownSignupLink")}
          hideMessage={() => {}}
          onTop
        />
      </CreateAccountCenterPreTestContainer>
    );
  } else if (linkStatus === "network-error" && isValidatedRoute) {
    SignupContent = (
      <CreateAccountCenterPreTestContainer deviceType={deviceType}>
        <ErrorPopup
          message={t("createAccount.errors.network")}
          hideMessage={() => {}}
          onTop
        />
      </CreateAccountCenterPreTestContainer>
    );
  }

  const InfoSummary = (
    <>
      <CreateAccountCenterFormPreTestInfoGrid deviceType={deviceType}>
        <CreateAccountCenterFormPreTestInfoTitle deviceType={deviceType}>
          {t("createAccount.preTest.infoTitle")}{" "}
        </CreateAccountCenterFormPreTestInfoTitle>
        <CreateAccountCenterFormPreTestInfoRow deviceType={deviceType}>
          {" "}
          <TestTube />{" "}
          <CreateAccountCenterFormPreTestInfoRowContent deviceType={deviceType}>
            {t("createAccount.preTest.nonInvasiveTesting")}
          </CreateAccountCenterFormPreTestInfoRowContent>{" "}
        </CreateAccountCenterFormPreTestInfoRow>
        <CreateAccountCenterFormPreTestInfoRow deviceType={deviceType}>
          {" "}
          <MaleFemale />{" "}
          <CreateAccountCenterFormPreTestInfoRowContent deviceType={deviceType}>
            {t("createAccount.preTest.predictsSex")}
          </CreateAccountCenterFormPreTestInfoRowContent>
        </CreateAccountCenterFormPreTestInfoRow>
        <CreateAccountCenterFormPreTestInfoRow deviceType={deviceType}>
          {" "}
          <PregnantWoman />{" "}
          <CreateAccountCenterFormPreTestInfoRowContent deviceType={deviceType}>
            {t("createAccount.preTest.resultsInTwoWeeks")}
          </CreateAccountCenterFormPreTestInfoRowContent>{" "}
        </CreateAccountCenterFormPreTestInfoRow>
      </CreateAccountCenterFormPreTestInfoGrid>
    </>
  );

  return (
    <>
      {isDesktop && (
        <div style={{ height: "100vh" }}>
          <BlankHeader link="https://unityscreen.com/" />
          <CreateAccountPretestDesktopContainer>
            {InfoSummary}
            {SignupContent}
          </CreateAccountPretestDesktopContainer>
        </div>
      )}
      {!isDesktop && (
        <>
          <BlankHeader link="https://unityscreen.com/" />
          <CreateAccountPretestMobileContainer>
            {InfoSummary}
            {SignupContent}
          </CreateAccountPretestMobileContainer>
        </>
      )}
    </>
  );
};
